import { readonly } from 'vue'
import { useAuthStore } from '@module/shared/store/authStore'

type NotNull<T> = Exclude<T, null | undefined>
type UserData = NotNull<ReturnType<typeof useAuthStore>['authData']>

export function useUserData(): Readonly<UserData> {
    const store = useAuthStore()
    if (!store.authData) return {} as any
    return readonly(store.authData) as any
}
